import { Button } from "../buttons/button";
import { Icon } from "../icons/icon";

export const ActionCard = ({
  svg,
  title,
  text,
  buttonText,
  isCompleted,
  className,
  onActionClick = () => {},
}: {
  svg: string;
  title: string;
  text: string;
  buttonText: string;
  isCompleted: boolean;
  className?: string;
  onActionClick?: () => void;
}) => {
  return (
    <div
      className={`
      px-[12px] py-[16px] md:py-4 md:px-6
      rounded-lg
      bg-light-green-bg
      flex gap-4
      items-center
      ${className}
      transition-all
      `}
    >
      <Icon svg={svg} width={32} height={32} className="md:hidden block" />

      <Icon svg={svg} width={48} height={48} className="hidden md:block" />

      <div className="flex-1 flex flex-col gap-1">
        <p className="text-sm md:text-base font-medium">{title}</p>
        {!isCompleted && (
          <p className="text-xs md:text-sm text-pry-lighter-green-200">
            {text}
          </p>
        )}
      </div>

      <div className="w-full max-w-[90px] md:max-w-[120px] flex items-center justify-center ml-auto">
        {!isCompleted ? (
          <Button
            text={buttonText}
            onClick={onActionClick}
            type="button"
            className="w-full !py-2  md:!py-3 text-xs md:!text-sm !font-medium"
            loading={false}
            disabled={false}
            variation="secondary-dark"
          />
        ) : (
          <div
            className="
            text-pry-green-200
            flex gap-1 items-center
            text-sm md:text-base font-medium
            "
          >
            <Icon
              svg="verified-icon"
              width={24}
              height={24}
              className={"scale-[0.8] md:scale-100"}
            />
            <span>Done</span>
          </div>
        )}
      </div>
    </div>
  );
};
